import React from 'react';
import "../../../resources/RTCC/css/common/radio_box_style.css";
import { Button } from '../../atoms/RTCC/button';
import { Label } from '../../atoms/RTCC/label';
import { ErrorMassage } from './errorMassage';
import { LabelInputForm } from './labelInputForm';

export const ConfirmPassportList = (props) => {
    const { representData, accompanyList, handleEdit, responsiveFlg } = props;


    const represent =
        <div className="passportInfoInnerWrap">
            <div className="passportInfoWrap">
                <div className="guestIndexLabelWrapper">
                    <Label
                        label={"代表者"}
                        className={props.titleClassName}
                    />
                </div>
                <div className="userInputConfirmWrapper">
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"氏名"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={representData.guestNameRoman}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"パスポート番号"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={representData.passportNumber}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"発行年月日"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={representData.issueDate}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"有効期間満了年月日"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={representData.validDate}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div >;

    const accompany = accompanyList.map((value, index) =>
        <div className="passportInfoInnerWrap" key={"accompany" + index}>
            <div className="passportInfoWrap">
                <div className="guestIndexLabelWrapper">
                    <Label
                        label={"同行者" + (Number(index) + 1)}
                        className="reserveConirmTitle"
                    />
                    <Label
                        label={"(" + value.ageGroup + ")"}
                        className="guestIndexLabel"
                    />
                </div>
                <div className="userInputConfirmWrapper">
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"氏名"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={value.guestNameRoman}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"パスポート番号"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={value.passportNumber}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"発行年月日"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={value.issueDate}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm2">
                        <ul style={responsiveFlg ? styles.ulStyleSp : styles.ulStyle}>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle}>
                                <Label
                                    className="inputTitleLabel"
                                    label={"有効期間満了年月日"}
                                />
                            </li>
                            <li style={responsiveFlg ? styles.liStyleSp : styles.liStyle2}>
                                <Label
                                    label={value.validDate}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="inputPassportWrapper">
            {represent}
            {accompany}
        </div>
    );
}

const styles = {
    confirmBlock: {
        display: "block",
        flexWrap: "wrap",
        paddingTop: "10px",
        borderTop: "1px solid rgb(173, 173, 173, 0.6)"
    },
    confirmFlex: {
        margin: "auto",
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center"
    },
    titleWrap: {
        display: "flex",
        justifyContent: "space-between"
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0.94)",
        border: 0,
        fontWeight: "bold"
    },
    ulStyle: {
        padding: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "0px auto 0px auto",
    },
    ulStyleSp: {
        padding: 0,
        width: "100%",
        height: "100%",
        display: "block",
        margin: "0px auto 20px auto",
    },
    ulStyle2: {
        padding: "5px 0px 5px 0px",
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "0px auto 0px auto",
    },
    liStyle: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liStyleSp: {
        listStyle: "none",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liStyle2: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liBtnStyle: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "right",
        padding: "0px 20px 0px 0px",
    },
}